var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-qtt"},_vm._l((_vm.qtt),function(player,index){return _c('div',{key:index,staticClass:"player"},[_c('img',{class:_vm.color == 'lightgray' ? 'black' : 'white',attrs:{"src":require("@/assets/img/utils/user.svg")}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }